export default __webpack_public_path__ + "static/media/BrainBreak cards39.a5cc2bd1.png";